import { useContext } from "react";
import { PrescriptionContext } from "./PrescriptionProvider";
import { PrescriptionWithMedication } from "src/api/types";

export function usePrescription<T>(
  selector: (prescription: PrescriptionWithMedication) => T,
) {
  const prescription = useContext(PrescriptionContext);

  if (prescription == null) {
    throw new Error("usePrescription is used outside of PrescriptionProvider");
  }

  return selector(prescription);
}
